import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./gallery.scss";

interface GalleryProps {
    images: string[];
}

const Gallery: React.FC<GalleryProps> = ({ images }) => {
    return (
        <>
            <Swiper
                id="gallery"
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ el: ".pagi", clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                modules={[Autoplay, Pagination]}
                loop
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className="image-wrapper"
                            style={{ backgroundImage: `url(${image})` }}
                        />
                    </SwiperSlide>
                ))}
                <div className="feel">
                    <h3>
                        FEEL THE <br />
                        DIFFERENCE
                    </h3>
                </div>
            </Swiper>
            <div className="pagi"></div>
        </>
    );
};

export default Gallery;
